var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{attrs:{"sm":"12","md":"12","lg":"12"}},[_c('v-row',{attrs:{"wrap":"","align-center":""}},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" Computation progress... "),_c('v-progress-linear',{attrs:{"color":"light-blue accent-4","indeterminate":"","rounded":"","height":"6"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }